import { LayoutLoading } from 'components/LayoutLoading'
import { SaveChanges } from 'components/SaveChanges'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getAdminConfig, setAdminConfig } from 'services'
import { Button } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

const CONFIG_KEY = 'signDisclosuresModal'

const FIELD_LABELS: Record<string, string> = {
  requiredDisclosuresHeading: 'Required Disclosures Heading',
  editFunctionalityWarning: 'Edit Functionality Warning',
  pricingNote: 'Pricing Note',
  viewPdfLinkText: 'View PDF Link Text',
  reviewToggleText: 'Review Toggle Label',
  signUrlAlertText: 'Sign URL Alert Text',
}

export const SignDisclosuresModal = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<Record<string, string>>({})
  const [changed, setChanged] = useState(false)

  useEffect(() => {
    setLoading(true)
    getAdminConfig(CONFIG_KEY)
      .then((res: any) => {
        if (res) setData(res)
      })
      .finally(() => setLoading(false))
  }, [])

  const onChange = (key: string, value: string) => {
    setData((prev) => ({ ...prev, [key]: value }))
    setChanged(true)
  }

  const onSubmit = async () => {
    setLoading(true)
    try {
      await setAdminConfig(CONFIG_KEY, data)
      toast('Saved successfully', { type: 'success' })
      setChanged(false)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="relative px-3 py-1.5 min-h-[400px]">
      <LayoutLoading show={loading} />

      <div className="text-xl font-bold mb-2">Sign Disclosures Modal</div>
      <p className="text-sm text-gray-500 mb-6">
        Customize the text shown in the &quot;Confirm and Sign Loan Disclosures&quot; modal. Leave a field blank to use
        the system default.
      </p>

      <div className="grid gap-5 max-w-3xl">
        {Object.keys(FIELD_LABELS).map((key) => (
          <RenderInput
            key={key}
            Key={key}
            input={{
              inputType: 'textarea',
              title: `${FIELD_LABELS[key]}`,
              value: data[key] ?? '',
              rows: 2,
            }}
            onChange={onChange}
          />
        ))}
      </div>

      <div className="flex justify-center mt-6">
        <Button onClick={onSubmit} loading={loading} disabled={!changed}>
          Save Changes
        </Button>
      </div>
      <SaveChanges show={changed} label="Save Changes" onSave={onSubmit} />
    </div>
  )
}
